module.exports = "/assets/81f3246ea92ba49a1a9ac168eeaf782b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/X8.png
// module id = 1987
// module chunks = 0